document.addEventListener("sections:loaded", () => {
  const drawer = document.getElementById("CartDrawer");
  if (!drawer) {
    return;
  }

  const body = drawer.querySelector("[data-cart-drawer-body]");
  const emptyState = drawer.querySelector("[data-cart-drawer-empty]");
  const itemsList = drawer.querySelector("[data-cart-drawer-items]");
  const subtotalEl = drawer.querySelector("[data-cart-drawer-subtotal]");
  const headerCountEls = document.querySelectorAll("[data-cart-count]");
  const drawerCountEl = drawer.querySelector("[data-cart-drawer-count]");
  const i18nQty = drawer.dataset.i18nQty || "Qty";
  const i18nRemove = drawer.dataset.i18nRemove || "Remove";
  const i18nAddToCartError = drawer.dataset.i18nAddToCartError || "Couldn't add this item to your cart.";
  let lastFocused = null;

  const moneyFormat = (cents) => `€${(cents / 100).toFixed(2)}`;

  const escapeHtml = (value) =>
    String(value).replace(/[&<>"']/g, (char) => (
      { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char]
    ));

  const itemMarkup = (item) => `
    <li class="cart-item" data-cart-item-key="${item.key}">
      <div class="cart-item-image-wrap">
        ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy" />` : ""}
      </div>
      <div class="cart-item-info">
        <a href="${item.url}" class="cart-item-title">${escapeHtml(item.product_title)}</a>
        ${item.variant_title && item.variant_title !== "Default Title" ? `<p class="cart-item-variant">${escapeHtml(item.variant_title)}</p>` : ""}
        <p class="cart-item-qty">${i18nQty}: ${item.quantity}</p>
        <button type="button" class="cart-item-remove" data-cart-item-remove data-key="${item.key}">${i18nRemove}</button>
      </div>
      <p class="cart-item-price">${
        item.original_line_price !== item.final_line_price
          ? `<s>${moneyFormat(item.original_line_price)}</s> ${moneyFormat(item.final_line_price)}`
          : moneyFormat(item.final_line_price)
      }</p>
    </li>
  `;

  const render = (cart) => {
    headerCountEls.forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    if (drawerCountEl) {
      drawerCountEl.textContent = `(${cart.item_count})`;
      drawerCountEl.hidden = cart.item_count === 0;
    }

    if (cart.item_count === 0) {
      if (emptyState) emptyState.hidden = false;
      if (body) body.hidden = true;
      if (itemsList) itemsList.innerHTML = "";
      if (subtotalEl) subtotalEl.textContent = moneyFormat(0);
      return;
    }

    if (emptyState) emptyState.hidden = true;
    if (body) body.hidden = false;
    if (itemsList) itemsList.innerHTML = cart.items.map(itemMarkup).join("");
    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
  };

  const fetchCart = async () => {
    const response = await fetch("/cart.js");
    return response.json();
  };

  const openDrawer = () => {
    lastFocused = document.activeElement;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("cart-drawer-open");
    const closeButton = drawer.querySelector(".cart-drawer-close");
    if (closeButton) closeButton.focus();
  };

  const closeDrawer = () => {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("cart-drawer-open");
    if (lastFocused) lastFocused.focus();
  };

  document.querySelectorAll("[data-cart-drawer-open]").forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      openDrawer();
    });
  });

  drawer.querySelectorAll("[data-cart-drawer-close]").forEach((el) => {
    el.addEventListener("click", (event) => {
      event.preventDefault();
      closeDrawer();
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && drawer.classList.contains("is-open")) {
      closeDrawer();
    }
  });

  const showFormError = (form, message) => {
    const errorEl = form.querySelector("[data-product-form-error]");
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = !message;
  };

  document.addEventListener("submit", async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes("/cart/add")) {
      return;
    }

    event.preventDefault();
    showFormError(form, "");

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
      });

      const data = await response.json();

      if (!response.ok) {
        showFormError(form, data.description || data.message || i18nAddToCartError);
        return;
      }

      const cart = await fetchCart();
      render(cart);
      openDrawer();
    } catch (error) {
      console.error(error);
      showFormError(form, i18nAddToCartError);
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  });

  const changeLine = async (key, quantity) => {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });

    const cart = await response.json();
    render(cart);
  };

  drawer.addEventListener("click", (event) => {
    const removeButton = event.target.closest("[data-cart-item-remove]");
    if (removeButton) {
      event.preventDefault();
      changeLine(removeButton.dataset.key, 0);
    }
  });
});
